import { Component } from '@angular/core';

import { AbstractCellComponent } from '@camelot/core';

import { MandateStatus } from '../../../services/dto/mandate-status';
import { MandateStatusComponent } from '../../mandate-status/mandate-status.component';

@Component({
  host: { 'data-cid': 'grid-mandate-status-cell' },
  imports: [MandateStatusComponent],
  selector: '',
  template: `<div class="align-center" style="height: 100%">
    <cam-mandate-status [status]="this.status"></cam-mandate-status>
  </div>`,
})
export class GridMandateStatusCellComponent extends AbstractCellComponent<any, MandateStatus> {
  get status() {
    return this.value ?? MandateStatus.Unknown;
  }
}
